import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { isFunction } from '@utiljs/is';
import confirm from './Confirm';

var WithConfirm = function WithConfirm(props) {
  var eventType = props.eventType,
      children = props.children,
      disabled = props.disabled,
      confirmChildren = props.confirmChildren,
      confirmProps = __rest(props, ["eventType", "children", "disabled", "confirmChildren"]);

  var catchEvent = function catchEvent(e, execute) {
    if (disabled) {
      if (isFunction(execute)) {
        execute();
      }

      return;
    }

    confirm(_Object$assign(_Object$assign({}, confirmProps), {
      children: confirmChildren,
      onOpen: function onOpen(confirmEvent, type) {
        var onOpen = confirmProps.onOpen;

        if (isFunction(execute)) {
          execute();
        }

        if (isFunction(onOpen)) {
          onOpen(confirmEvent, type);
        }
      },
      onClose: function onClose(confirmEvent, type) {
        var onClose = confirmProps.onClose;

        if (isFunction(onClose)) {
          onClose(confirmEvent, type);
        }
      }
    }));
  };

  var comProps = _defineProperty({}, eventType, function (e) {
    return catchEvent(e, children.props[eventType]);
  });

  if ( /*#__PURE__*/React.isValidElement(children)) {
    return /*#__PURE__*/React.cloneElement(children, comProps);
  }

  return null;
};

WithConfirm.defaultProps = {
  eventType: 'onClick',
  disabled: false
};
WithConfirm.propTypes = {
  eventType: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export default WithConfirm;